export const SHARED_REPORTS_EXPIRATION_DAYS_CHOICES = [1, 7, 14, 30, 90, 120, 150, 180, 270, 365];
export const SHARED_REPORTS_DEFAULT_DAYS = 30;
export const SHARED_REPORTS_ANONYMOUS_ENDPOINT = '/react/anonymous/#/react/anonymous/';
